<script setup lang="ts">
/**
 * Group table cell: active/ended state — mirrors the sketch's `.g-state`.
 * `active` is computed by the caller via `isGroupActive` (no end date, or
 * its end date hasn't passed yet; the backend derives it the same way
 * rather than storing it as its own column).
 */
import { useI18n } from 'vue-i18n'

defineProps<{
  active: boolean
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()

const { t } = useI18n()
</script>

<template>
  <td
    class="font-tufte-sans"
    :style="{
      fontSize: 'var(--text-tufte-xs)',
      textAlign: 'center',
      ...(maxWidth ? { maxWidth, overflowWrap: 'break-word' } : {}),
    }"
  >
    <span v-if="active" class="group-state-cell--on">{{ t('cards.group.stateActive') }}</span>
    <span v-else class="text-tufte-muted">{{ t('cards.group.stateInactive') }}</span>
  </td>
</template>

<style scoped>
.group-state-cell--on {
  color: var(--color-tufte-success);
}
</style>
